import { FeedbackContext } from "@/context-providers/FeedbackContext";
import { useContext } from "react";

export const useFeedbackModal = () => {
  const { showFeedbackModal, ratedSessionIds, closeFeedbackModal } = useContext(FeedbackContext);
  return { showFeedbackModal, ratedSessionIds, closeFeedbackModal };
};
